import React, { useState } from 'react'
import { ContainerDetalhes } from './styled'

import {
  faCalendar,
  faChartArea,
  faChevronRight,
  faFlask,
  faList,
  faMap,
  faSeedling,
  faUsers,
  faUsersLine,
  faVihara,
} from '@fortawesome/free-solid-svg-icons'
import DatePickerCustom from '../../../../../../../../Components/CustomUi/datePicker'
import Input from '../../../../../../../../Components/CustomUi/input'
import { Select } from '../../../../../../../../Components/CustomUi/Select'
import { Collapse, Tag } from 'antd'
import Tabs from '../../../../../../../../Components/Tabs'
import { SelectMulti } from '../../../../../../../../Components/CustomUi/SelectMulti'
import type { TalhaoItens } from '../../../../../../../../services/Talhao'
import { dados_status } from '../../../tabela/components/statusTimeLine/meta'
import { buscarAnalisesPorLab, statusIcones } from '../../../meta'
import dayjs from 'dayjs'
import type { ClienteItensTypes } from '../../../../../../../../services/Cliente'
import { Render } from '../../../../../../../../Components/CustomUi/render'
import type { SafraItens } from '../../../../../../../../services/Safra'
import type { RepresentanteLegalItens } from '../../../../../../../../services/RepresentanteLegal'
import Carregando from '../../../../../../../../Components/CustomUi/loading'
import type { Item__EquipeCliente } from '../../../../../../../../services/Equipe/GET'
import { PropsTiposAnalise } from '../../../..'
interface PropsDetalhes {
  update: number
  loading_formulario: boolean
  dados_cliente: ClienteItensTypes
  data_representante: RepresentanteLegalItens[]
  status_atual: string
  setStatus_atual: React.Dispatch<React.SetStateAction<string>>
  setStatus_atual_id: React.Dispatch<React.SetStateAction<number>>
  data_da_os: string
  setData_da_os: React.Dispatch<React.SetStateAction<string>>
  outros_solicitantes: string
  setOutros_solicitantes: React.Dispatch<React.SetStateAction<string>>
  propriedade: string
  setPropriedade: React.Dispatch<React.SetStateAction<string>>
  setPropriedade_id: React.Dispatch<React.SetStateAction<number>>
  talhao: string
  setTalhao: React.Dispatch<React.SetStateAction<string>>
  setTalhao_id: React.Dispatch<React.SetStateAction<number>>
  matricula: string
  area_propriedade: string
  laboratorio: string
  setLaboratorio: React.Dispatch<React.SetStateAction<string>>
  setLaboratorio_id: React.Dispatch<React.SetStateAction<number>>
  safra_consultoria: string
  setSafra_consultoria: React.Dispatch<React.SetStateAction<string>>
  setSafra_consultoria_id: React.Dispatch<React.SetStateAction<number>>
  area_amostra_laudo: string
  setArea_amostra_laudo: React.Dispatch<React.SetStateAction<string>>
  responsaveis_selecionados: { descr: string; id: number; key?: number }[]
  setResponsaveis_selecionados: React.Dispatch<
    React.SetStateAction<{ descr: string; id: number; key?: number }[]>
  >
  coleta_liberada: string
  setColeta_liberada: React.Dispatch<React.SetStateAction<string>>
  coletada_em: string
  setColetada_em: React.Dispatch<React.SetStateAction<string>>
  representante_selecionado: string
  setRepresentante_selecionado: React.Dispatch<React.SetStateAction<string>>
  setRepresentante_selecionado_id: React.Dispatch<React.SetStateAction<number>>
  setOpen_loading_analise_lab: React.Dispatch<React.SetStateAction<boolean>>
  setGrupoAnalises: React.Dispatch<React.SetStateAction<any[]>>
  setAnalises_nao_encontradas: React.Dispatch<React.SetStateAction<any[]>>,
  setValores_analises_editados: React.Dispatch<React.SetStateAction<any[]>>
  setOpen_modal_confirm_lab: React.Dispatch<React.SetStateAction<boolean>>
  analises: any[]
  setAnalises: React.Dispatch<React.SetStateAction<any[]>>
  tipo_de_analise: string
  setTipo_de_analise: React.Dispatch<React.SetStateAction<string>>
  dataPropriedades: { nome: string; cod: number }[]
  dataTalhoes: TalhaoItens[]
  data_laboratorio: any[]
  data_safra_consultoria: SafraItens[]
  data_equipe: Item__EquipeCliente[]
  data_tipos_analise: PropsTiposAnalise[]
  buscarTalhaoPropriedade: Function
}

export const DetalhesClientes: React.FC<PropsDetalhes> = ({
  update,
  loading_formulario,
  area_amostra_laudo,
  setArea_amostra_laudo,
  dados_cliente,
  data_representante,
  status_atual,
  setStatus_atual,
  setStatus_atual_id,
  data_da_os,
  setData_da_os,
  outros_solicitantes,
  setOutros_solicitantes,
  propriedade,
  setPropriedade,
  setPropriedade_id,
  talhao,
  setTalhao,
  setTalhao_id,
  matricula,
  area_propriedade,
  laboratorio,
  setLaboratorio,
  setLaboratorio_id,
  safra_consultoria,
  setSafra_consultoria,
  setSafra_consultoria_id,
  responsaveis_selecionados,
  setResponsaveis_selecionados,
  coleta_liberada,
  setColeta_liberada,
  coletada_em,
  setColetada_em,
  representante_selecionado,
  setRepresentante_selecionado,
  setRepresentante_selecionado_id,
  setOpen_loading_analise_lab,
  setGrupoAnalises,
  setAnalises_nao_encontradas,
  setValores_analises_editados,
  setOpen_modal_confirm_lab,
  analises,
  setAnalises,
  tipo_de_analise,
  setTipo_de_analise,
  dataPropriedades,
  dataTalhoes,
  data_laboratorio,
  data_safra_consultoria,
  data_equipe,
  data_tipos_analise,
  buscarTalhaoPropriedade,
}) => {
  const [openStatus, setOpenStatus] = useState<boolean>(false)
  const [openPropriedade, setOpenPropriedade] = useState<boolean>(false)
  const [openLaboratorio, setOpenLaboratorio] = useState<boolean>(false)
  const [openSafra, setOpenSafra] = useState<boolean>(false)
  const [openResponsaveis, setOpenResponsaveis] = useState<boolean>(false)
  const [openTalhao, setOpenTalhao] = useState<boolean>(false)
  const [openRepresentante, setOpenRepresentante] = useState<boolean>(false)
  const [openTipoAnalise, setOpenTipoAnalise] = useState<boolean>(false)

  return (
    <ContainerDetalhes>
      <Render condition={loading_formulario === false}>
        <Collapse
          defaultActiveKey={[]} // Começa fechado como na foto
          style={{
            backgroundColor: '#d9d9d9',
            borderRadius: '8px', // Define o arredondamento
            overflow: 'hidden', // O SEGREDO: Corta o que passar do arredondamento (corrige os cantos)
          }}
          items={[
            {
              key: '1',
              label: <span style={{ fontWeight: 600 }}>Detalhe do cliente</span>,
              children: (
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr auto',
                    gap: '12px 16px',
                  }}
                >
                  <div style={{ gridColumn: 'span 2' }}>
                    <div style={{ fontSize: '12px', color: '#a0a0a0', fontWeight: '700' }}>Nome</div>
                    <div style={{ fontWeight: 500, color: '#262626' }}>{dados_cliente?.nome}</div>
                  </div>

                  <div>
                    <div style={{ fontSize: '12px', color: '#a0a0a0', fontWeight: '700' }}>
                      Endereço
                    </div>
                    <div style={{ fontWeight: 500, color: '#262626' }}>{dados_cliente?.endereco}</div>
                  </div>

                  <div>
                    <div style={{ fontSize: '12px', color: '#a0a0a0', fontWeight: '700' }}>Num</div>
                    <div style={{ fontWeight: 500, color: '#262626' }}>
                      {dados_cliente?.endereco_numero}
                    </div>
                  </div>

                  <div>
                    <div style={{ fontSize: '12px', color: '#a0a0a0', fontWeight: '700' }}>
                      Cidade
                    </div>
                    <div style={{ fontWeight: 500, color: '#262626' }}>
                      {dados_cliente?.cidade?.nome || 'Cidade não informada'}
                    </div>
                  </div>

                  <div>
                    <div style={{ fontSize: '12px', color: '#a0a0a0', fontWeight: '700' }}>CEP</div>
                    <div style={{ fontWeight: 500, color: '#262626' }}>{dados_cliente?.cep}</div>
                  </div>
                </div>
              ),
              style: { background: '#fff' }, // Força o fundo branco no item específico também
            },
          ]}
        />

        <Render condition={dados_cliente?.tipo === 'G'}>
          <Select
            value={representante_selecionado}
            onChange={setRepresentante_selecionado}
            onChangeID={setRepresentante_selecionado_id}
            open={openRepresentante}
            trigger={setOpenRepresentante}
            items={data_representante}
            descricaoItem={'nome'}
            idItem={'cod'}
          />
        </Render>

        <Render condition={update > 0}>
          <Select
            label='Status atual'
            placeholder='Selecione o status atual'
            icon={statusIcones[status_atual]}
            value={status_atual}
            onChange={setStatus_atual}
            onChangeID={setStatus_atual_id}
            open={openStatus}
            trigger={setOpenStatus}
            items={dados_status}
            descricaoItem={'nome'}
            idItem={'cod'}
            obrigatorio
          />
        </Render>

        <Select
          label='Tipo da análise'
          placeholder='Selecione o tipo da análise'
          icon={faFlask}
          value={tipo_de_analise}
          onChange={setTipo_de_analise}
          open={openTipoAnalise}
          trigger={setOpenTipoAnalise}
          items={data_tipos_analise}
          descricaoItem={'nome'}
          idItem={'cod'}
          obrigatorio
        />

        <DatePickerCustom
          label='Data O.S'
          icon={faCalendar}
          value={data_da_os ? dayjs(data_da_os) : null}
          onChange={setData_da_os}
          width={150}
          obrigatorio
        />
        <Input
          label='Outros solicitantes'
          icon={faUsers}
          placeholder='Digite os outros solicitantes'
          value={outros_solicitantes}
          onChange={setOutros_solicitantes}
          obrigatorio
        />
        <div className='detalhe__propriedade'>
          <Select
            label='Propriedade'
            placeholder='Selecione a propriedade'
            icon={faVihara}
            value={propriedade}
            onChange={setPropriedade}
            onChangeID={(e) => buscarTalhaoPropriedade(e)}
            open={openPropriedade}
            trigger={setOpenPropriedade}
            items={dataPropriedades}
            descricaoItem={'nome'}
            idItem={'cod'}
            obrigatorio
          />
          <div>
            <Tag style={{ border: '1px solid #0958D9', color: '#0958D9' }} color='#E6F4FF'>
              Matrícula: {matricula}
            </Tag>
            <Tag style={{ border: '1px solid #B7EB8F', color: '#52C41A' }} color='#F6FFED'>
              Área: {area_propriedade} ha
            </Tag>
          </div>
        </div>
        <Select
          label='Talhão'
          value={talhao}
          placeholder='Selecione o talhão'
          icon={faMap}
          onChange={setTalhao}
          onChangeID={setTalhao_id}
          open={openTalhao}
          trigger={setOpenTalhao}
          items={dataTalhoes}
          descricaoItem={'nome'}
          idItem={'cod'}
          hasTalhaoSVG
          talhaoSvgPath={['coordenadas']}
          obrigatorio
        />
        <Select
          label='Laboratório'
          placeholder='Selecione o laboratório'
          icon={faFlask}
          value={laboratorio}
          onChange={setLaboratorio}
          onChangeID={(e) =>
            buscarAnalisesPorLab(
              e,
              update,
              setLaboratorio_id,
              setOpen_loading_analise_lab,
              data_da_os,
              setGrupoAnalises,
              setAnalises_nao_encontradas,
              setValores_analises_editados,
              setOpen_modal_confirm_lab,
              analises,
              setAnalises
            )
          }
          open={openLaboratorio}
          trigger={setOpenLaboratorio}
          items={data_laboratorio}
          descricaoItem={'nome'}
          idItem={'cod'}
          obrigatorio
        />
        <Select
          label='Safra consultoria'
          placeholder='Selecione a safra consultoria'
          icon={faSeedling}
          value={safra_consultoria}
          onChange={setSafra_consultoria}
          onChangeID={setSafra_consultoria_id}
          open={openSafra}
          trigger={setOpenSafra}
          items={data_safra_consultoria?.sort((a, b) => b.cod - a.cod)}
          descricaoItem={'nome'}
          idItem={'cod'}
          obrigatorio
        />
        <div>
          <label
            style={{
              fontSize: '13px',
              fontWeight: 500,
              color: '#2D3436',
              display: 'inline-flex',
              gap: '5px',
            }}
          >
            Área de amostra no laudo
          </label>
          <Tabs
            tabs={[
              { icone: '', descricao: '50 ha' },
              { icone: '', descricao: '20 ha' },
            ]}
            selecionado={area_amostra_laudo}
            onChange={setArea_amostra_laudo}
            trackWidth={55}
            width={120}
          />
        </div>
        <SelectMulti
          label='Responsáveis pela coleta'
          placeholder='Selecione o responsável pela coleta'
          icon={faUsersLine}
          open={openResponsaveis}
          trigger={setOpenResponsaveis}
          items={data_equipe}
          descricaoItem={'usuario_nome'}
          idItem={'cod_func'}
          selecteds={responsaveis_selecionados}
          onChange={setResponsaveis_selecionados}
          obrigatorio
        />
        <div style={{ display: 'flex', gap: 10 }}>
          <DatePickerCustom
            label='Coleta liberada'
            icon={faCalendar}
            value={coleta_liberada ? dayjs(coleta_liberada) : null}
            onChange={setColeta_liberada}
            width={180}
            obrigatorio
          />
          <Render condition={update > 0 && status_atual === 'COLETADA'}>
            <DatePickerCustom
              label='Coletado em'
              icon={faCalendar}
              value={coletada_em ? dayjs(coletada_em) : null}
              onChange={setColetada_em}
              width={180}
              obrigatorio
            />
          </Render>
        </div>
      </Render>
      <Render condition={loading_formulario}>
        <Carregando animation justifyContent='center' height={'500px'} legenda='Carregando informações...' />
      </Render>
    </ContainerDetalhes>
  )
}
